import React from 'react';

import ManualTransactionsPage from './ManualTransactionsPage';

export const ManualDeposits: React.FC = () =>
  React.createElement(ManualTransactionsPage, { kind: 'deposit' });

export const ManualWithdrawals: React.FC = () =>
  React.createElement(ManualTransactionsPage, { kind: 'withdraw' });

export default ManualTransactionsPage;
